import { Reducer } from '@reduxjs/toolkit';

const openBatchProcessesReducer: Reducer = (state, { payload }) => ({
  ...state,
  anchorEl: payload,
});

export default openBatchProcessesReducer;
